<div
	*ngIf="pagingData && pageSize && (pageCount > 1 || pagingData.continuesPagesMode)"
	class="paginationWrapper d-flex"
	[ngClass]="{
		'fullMode': pagingData.mode === pagingModeEnum.Full,
		'lightMode': pagingData.mode === pagingModeEnum.Light,
		'activeOperation': activeOperation,
		'isOpen': showBody
	}"
>

	<ng-container [ngSwitch]="pagingData.mode">
		<ng-container *ngSwitchCase="pagingModeEnum.Full">
			<ng-container *ngTemplateOutlet="fullPagingTpl"></ng-container>
		</ng-container>

		<ng-container *ngSwitchCase="pagingModeEnum.Light">
			<ng-container *ngIf="pageCount > maxPagesAsNumbers || pagingData.continuesPagesMode">
				<ng-container *ngTemplateOutlet="lightPagingTpl"></ng-container>
			</ng-container>

			<ng-container *ngIf="pageCount <= maxPagesAsNumbers && !pagingData.continuesPagesMode">
				<ng-container *ngTemplateOutlet="lightUpToFivePagesTpl"></ng-container>
			</ng-container>
		</ng-container>
	</ng-container>
</div>

<!-- ######################### TEMPLATES ######################### -->
<!-- Light Up to Five Paging -->
<ng-template #lightUpToFivePagesTpl>
	<div class="d-flex">
		<div class="d-flex flex-nowrap operator-body">
			<span
				*ngFor="let pageItemNumber of pageCountList; index as idx"
				class="me-2 pageNumber"
				[ngClass]="{'active': idx + 1 === pageNumber}"
				(click)="onUserInput(idx + 1)"
			>
				{{ pageItemNumber }}
			</span>
		</div>
	</div>
</ng-template>

<!-- Light Paging -->
<ng-template #lightPagingTpl>
<div class="d-flex">
		<div class="d-flex flex-nowrap operator-body">

			<button
				class="btn iconBtn entity-icon-sm--toggle"
				[ngClass]="{'disabled': disableBackwardStep}"
				data-e2e-open-bp-button
				(click)="prevPage()">
				<i class="ft-chevron-left"></i>
			</button>

			<input
				*ngIf="!pagingData.continuesPagesMode"
				type="number"
				min="1"
				max="{{pageCount}}"
				step="1"
				class="text-end px-0"
				[ngClass]="{ 'disabled': pageCount <= 1 }"
				[value]="pageNumber"
				(keyup)="onInputChange($event)"
			>

			<span
				[ngClass]="{
				'disabled': pageCount <= 1,
				'pageNumber px-0 mx-2 align-self-center': pagingData.continuesPagesMode
				}"
			>
				{{ pagingData.continuesPagesMode ? pageNumber : '/' + pageCount }}
			</span>

			<button
				class="btn iconBtn entity-icon-sm--toggle"
				[ngClass]="{'disabled': disableForwardStep}"
				data-e2e-open-bp-button
				(click)="nextPage()">
				<i class="ft-chevron-right"></i>
			</button>
		</div>
	</div>
</ng-template>

<!-- Full Paging -->
<ng-template #fullPagingTpl>
	<div class="d-flex w-100">
		<i
			class="operator-icon icon-docs vertical-separator--right"
			(click)="toggleBodyVisibility()"
		></i>

		<div
			class="operator-title"
			(click)="toggleBodyVisibility()"
		>
			<span class="me-2">{{ getI18nString( false, 'shared.listOperations.pagination' ) }}</span>
			<span>{{ pageNumber + '/' + pageCount }}</span>
		</div>

		<div class="d-flex flex-nowrap operator-body">

			<button
				*ngIf="!pagingData.continuesPagesMode"
				class="btn iconBtn entity-icon-sm--toggle"
				[ngClass]="{'disabled': disableBackwardStep}"
				data-e2e-open-bp-button
				(click)="firstPage()">
				<i class="ft-chevrons-left"></i>
			</button>

			<button
				class="btn iconBtn entity-icon-sm--toggle"
				[ngClass]="{'disabled': disableBackwardStep }"
				data-e2e-open-bp-button
				(click)="prevPage()">
				<i class="ft-chevron-left"></i>
			</button>

			<input
				type="number"
				min="1"
				max="{{pageCount}}"
				step="1"
				class="text-end px-0"
				[ngClass]="{ 'disabled': pageCount <= 1 }"
				[value]="pageNumber"
				(keyup)="onInputChange($event)">
			<span
				[ngClass]="{
				'disabled': pageCount <= 1,
				'pageNumber px-0 mx-2 align-self-center': pagingData.continuesPagesMode
				}"
			>{{ pagingData.continuesPagesMode ? pageNumber : '/' + pageCount }}</span>

			<button
				class="btn iconBtn entity-icon-sm--toggle"
				[ngClass]="{'disabled': disableForwardStep }"
				data-e2e-open-bp-button
				(click)="nextPage()">
				<i class="ft-chevron-right"></i>
			</button>

			<button
				class="btn iconBtn entity-icon-sm--toggle"
				[ngClass]="{'disabled': disableForwardStep }"
				data-e2e-open-bp-button
				(click)="lastPage()">
				<i class="ft-chevrons-right"></i>
			</button>
		</div>
	</div>
</ng-template>
